<template>
    <div id="home">
        <section class="section home-hero animate__animated animate__fadeIn">
            <div class="grid-container max">
                <div class="home-hero-grid">
                    <div class="home-hero-left">
                        <div class="home-hero-top">
                            <div class="home-hero-top-inner">
                                <h1>Put your best<br />plan forward</h1>
                                <p class="home-hero-subtitle">Health coverage built<br />for what&rsquo;s ahead</p>
                            </div>
                        </div>
                        <div class="home-hero-bottom">
                            <div class="home-hero-bottom-inner">
                                <p class="home-hero-welcome">Welcome to the 2027 Anthem Blue Cross and Blue Shield interactive health plan guide</p>
                                <p class="home-hero-desc">This interactive guide is designed to take you step-by-step to find the plan that best meets your needs and health goals.</p>
                                <router-link to="/intro" class="home-hero-btn"><span>Next</span></router-link>
                            </div>
                            <div class="home-hero-icon">
                                <img src="@/assets/img/home-hero-icons-2026.svg" alt="" />
                            </div>
                        </div>
                    </div>
                    <div class="home-hero-right">
                        <picture>
                            <source media="(max-width: 959px)" srcset="@/assets/img/home-hero-mobile-2026.jpg">
                            <img src="@/assets/img/home-hero-2026-lg.jpg" alt="Father and son playing together outside" />
                        </picture>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "SHBPHome",
    data() {
        return {
            pop: "Variable Field"
        }
    },
    mounted() {
        window.scrollTo(0, 0)
    }
}

</script>

<style lang="scss">
#home {
    .home-hero {
        margin-top: 68px;
        padding: 0;

        .grid-container.max {
            max-width: 100vw !important;
            padding: 0;
        }

        .home-hero-grid {
            display: flex;
            min-height: calc(100vh - 68px);

            @media only screen and (max-width: 959px) {
                flex-direction: column;
                min-height: calc(100vh - 68px);
            }
        }

        .home-hero-left {
            flex: 0 0 50%;
            max-width: 50%;
            display: flex;
            flex-direction: column;

            @media only screen and (max-width: 959px) {
                flex: 1 1 auto;
                max-width: 100%;
            }
        }

        .home-hero-top {
            background-color: #1355E9;
            color: #ffffff;
            padding: clamp(40px, 7.6vh, 96px) 64px clamp(30px, 5.6vh, 64px) 64px;
            flex: 55 1 auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            text-align: left;

            h1 {
                font-family: "Elevance Sans", "Montserrat", "Helvetica Neue", Arial, sans-serif;
                font-size: clamp(1.75rem, min(7.6vh, 4.3vw), 5.25rem) !important;
                font-weight: 600;
                line-height: 1 !important;
                margin-bottom: clamp(12px, 2.2vh, 24px);
            }

            .home-hero-subtitle {
                color: #ffffff;
                font-size: clamp(1.125rem, min(3.1vh, 1.9vw), 2.125rem) !important;
                font-weight: 400;
                line-height: 1.3;
                margin-bottom: 0 !important;
            }

            @media only screen and (max-width: 640px) {
                padding: 40px 24px 32px 24px;

                h1 {
                    font-size: 2.625rem !important;
                }

                .home-hero-subtitle {
                    font-size: 1.125rem !important;
                }
            }
        }

        .home-hero-bottom {
            background-color: #00305B;
            color: #ffffff;
            padding: clamp(8px, 1.6vh, 16px) 64px clamp(12px, 2vh, 20px) 64px;
            position: relative;
            flex: 45 1 auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            text-align: left;

            .home-hero-bottom-inner {
                max-width: 440px;
            }

            .home-hero-welcome {
                color: #ffffff;
                font-size: clamp(1.25rem, 2.5vh, 1.75rem) !important;
                font-weight: 600;
                line-height: 1.3;
                margin: 0 0 clamp(10px, 1.8vh, 20px) 0 !important;
            }

            .home-hero-desc {
                color: rgba(255, 255, 255, 0.85);
                font-size: clamp(0.875rem, 1.45vh, 1rem) !important;
                font-weight: 400;
                line-height: 1.5;
                margin: 0 0 clamp(16px, 2.9vh, 32px) 0 !important;
            }

            .home-hero-btn {
                display: inline-block;
                background-color: #1355E9;
                color: #ffffff !important;
                font-weight: 700;
                text-transform: uppercase;
                font-size: 1rem;
                padding: clamp(12px, 1.6vh, 18px) 0;
                width: 100%;
                max-width: 330px;
                text-align: center;
                border-radius: 30px;

                &:hover {
                    background-color: #44B8F3;
                }
            }

            .home-hero-icon {
                position: absolute;
                right: 0;
                bottom: 0;
                width: 28%;
                max-width: 220px;

                img {
                    display: block;
                    width: 100%;
                    height: auto;
                }
            }

            @media only screen and (max-width: 640px) {
                padding: 32px 24px 40px 24px;

                .home-hero-welcome {
                    font-size: 1.25rem !important;
                }

                .home-hero-btn {
                    max-width: 100%;
                }

                .home-hero-icon {
                    display: none;
                }
            }
        }

        .home-hero-right {
            flex: 0 0 50%;
            max-width: 50%;
            position: relative;
            overflow: hidden;

            img {
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

            @media only screen and (max-width: 959px) {
                order: -1;
                flex: 0 0 280px;
                max-width: 100%;
                height: 280px;

                img {
                    position: absolute;
                }
            }
        }
    }
}
</style>